export default {
      id: "icon-24-saat-guvenlik-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-24-saat-guvenlik",
      toString: function () {
        return this.url;
      }
    }